var scope_0 = require('C:/Users/Sourav Verma/Desktop/All Blog/BizDamn/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e092b9ed8da9cd484b31b22cbbd64fb3.js').default;
var scope_1 = require('C:/Users/Sourav Verma/Desktop/All Blog/BizDamn/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    